import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ReactGA from 'react-ga4';
import { Modal, ModalBody, ModalHeader, Row, Col, Button } from 'reactstrap';
import PageTitle from '../components/Common/PageTitle';
import ChangePasswordForm from '../forms/ChangePasswordForm';
import { submissionError } from '../actions/formActions';
import { changePassword } from '../actions/authActions';

class ChangePasswordModal extends Component {
  render() {
    const { isOpen, toggle, doChangePassword, showSubmissionError, user } = this.props;
    const { id, email } = user;
    if (isOpen) {
      ReactGA.send({ hitType: 'pageview', page: '/modal/changePassword', title: 'Change Password' });
    }
    return (
      <Modal isOpen={isOpen} toggle={toggle} onClosed={this.resetState} className="modal-medium">
        <ModalHeader toggle={toggle}>
          <PageTitle title="Change Password" showTeam={false} icon="fa-1x icon-lock" />
        </ModalHeader>
        <ModalBody>
          <Row className="mt-4">
            <Col xs={12}>
              <ChangePasswordForm
                showSubmissionError={showSubmissionError}
                onSubmit={(values) => {
                  doChangePassword({ username: email, ...values });
                  toggle();
                }}
                onCancel={toggle}
              />
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    );
  }
}

ChangePasswordModal.propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
  doChangePassword: PropTypes.func,
  showSubmissionError: PropTypes.func,
  user: PropTypes.instanceOf(Object),
};

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({
  doChangePassword: (values) => dispatch(changePassword(values)),
  showSubmissionError: (errors) => dispatch(submissionError(errors)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChangePasswordModal);
